import { PaymentConfig } from '../../../models/paymentConfig';

export const config: PaymentConfig = {
  data: {
    protocolRewardConfig: {
      requestProcessorSyncOnUserAction: false,
    },
    paymentCategories: [
      {
        name: 'some reason',
        id: '1',
      },
      {
        name: 'some reason 2',
        id: '2',
      },
    ],
    paymentSubcategories: [
      {
        id: '234',
        name: 'Payment type 1',
        amount: 10,
        config: null,
        currency: 'USD',
      },
      {
        id: '567',
        name: 'Payment type 2',
        amount: 20,
        config: null,
        currency: 'USD',
      },
    ],
    paymentAllowPatientSubmit: null,
    expenseCategories: [],
  },
  fetchCategories: async (): Promise<void> => {},
  fetchSubcategories: async (): Promise<void> => {},
  fetchAllowPatientSubmit: async (): Promise<void> => {},
  fetchExpenseCategories: async (): Promise<void> => {},
  fetchProtocolRewardConfig: async (): Promise<void> => {},
};
